import { render } from "./MobileNavbar.vue?vue&type=template&id=1b2bcea8"
import script from "./MobileNavbar.vue?vue&type=script&lang=js"
export * from "./MobileNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__